import React from 'react'
import { Button } from './utils'

export default function Navbar() {
  return (

       <nav className="navbar  navbar-dark bg-dark fixed-top border-bottom border-info border-3 ">
  <div className="container-fluid ">
    <div className="navbar-brand">CV Builder</div>
   
   
  </div>
</nav>

  )
}
